import { userRoles } from "utils/shared/variables";

export const getRoleText = (roleVal) => {
  let rtext = "";
  userRoles.forEach(function (item) {
    if (item.code === roleVal) {
      rtext = item.text;
    }
  });
  return rtext.length > 0 ? rtext : roleVal;
};

export const getStyles = (name, personName, theme) => {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
};
